import { resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { computed, defineComponent, useCssModule, provide, ref, onMounted, onUnmounted, nextTick } from "vue";
import { Btn, Icon } from "linkd-ui";
import YQueryItem1 from "./YQueryItem.vue";
const YQueryItem = YQueryItem1;
export default defineComponent({
  props: {
    searchText: {
      type: String,
      default: "查询"
    },
    hasSearchButton: {
      type: Boolean,
      default: true
    },
    flexEnd: {
      type: Boolean,
      default: false
    },
    spaceBetween: {
      type: Boolean,
      default: true
    },
    equal: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    },
    gutter: {
      type: String,
      default: ""
    },
    //是否显示展开收起的提示
    isSpread: {
      type: Boolean,
      default: false
    },
    //是否默认展开（仅初始状态，展开/收起交互不受影响）
    defaultExpand: {
      type: Boolean,
      default: false
    },
    //历史遗留别名：部分页面误写 spread，等价于 isSpread + defaultExpand，避免查询区收起且无展开入口
    spread: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Btn,
    Icon,
    YQueryItem
  },
  setup(props, ctx) {
    const css = useCssModule("css");
    const visible = ref(props.defaultExpand || props.spread);
    let isSpread = ref(props.isSpread || props.spread);
    //折叠态的最大高度：按第一行查询项实际高度动态测量，避免写死高度裁切遮挡内容
    const collapsedMaxHeight = ref(0);
    const tableBox = ref();
    let resizeObserver = null;
    const measureCollapsedHeight = () => {
      nextTick(() => {
        const root = tableBox.value;
        if (!root) {
          return;
        }
        //取左侧查询项容器（第一个 .q），找到第一行（offsetTop 相同）子项的最大高度
        const q = root.querySelectorAll(`.${css.q}`)[0];
        const items = q ? Array.from(q.children) : [];
        if (!items.length) {
          return;
        }
        const firstTop = items[0].offsetTop;
        let h = 0;
        items.forEach(item => {
          if (item.offsetTop === firstTop) {
            h = Math.max(h, item.offsetHeight);
          }
        });
        if (h > 0) {
          collapsedMaxHeight.value = h;
        }
      });
    };
    //类名设置
    const queryClass = computed(() => {
      return {
        [css.query]: true,
        [css.expanded]: isSpread.value && !visible.value,
        [css.flex_end]: props.flexEnd,
        [css.space_between]: props.spaceBetween
      };
    });
    //内容显示
    const content = computed(() => {
      //筛选的展开与收起
      let moreFilter = _createVNode("div", {
        "class": css.cursor,
        "onClick": () => visible.value = !visible.value
      }, [_createTextVNode("\u66F4\u591A\u7B5B\u9009"), _createVNode(Icon, {
        "name": "w-icon-arrow-down",
        "rotate": visible.value,
        "color": "#aaa"
      }, null)]);
      //query里的内容
      let querycontent = [props.hasSearchButton ? _createVNode(_resolveComponent("y-query-item"), null, {
        default: () => [_createVNode(Btn, {
          "type": "primary",
          "onClick": el => {
            ctx.emit("search");
          }
        }, {
          default: () => [props.searchText]
        })]
      }) : null, ctx.slots.append?.(), isSpread.value ? _createVNode(_resolveComponent("y-query-item"), null, {
        default: () => [_createTextVNode(" "), moreFilter, _createTextVNode(" ")]
      }) : null];
      if (props.spaceBetween) {
        querycontent = [_createVNode("div", {
          "class": css.q
        }, [ctx.slots.default?.()]), _createVNode("div", {
          "class": [css.q, css.bottom]
        }, [querycontent])];
      }
      return querycontent;
    });
    const getWidth = () => {
      nextTick(() => {
        measureCollapsedHeight();
        if (tableBox.value && !props.isSpread && !props.spread) {
          //div容器获取tableBox.value.clientWidth
          let newWidth = tableBox.value.clientWidth;
          // width.value = (newWidth - 450) / 2;
          if (newWidth <= 1400) {
            isSpread.value = true;
          } else {
            isSpread.value = false;
          }
        }
      });
    };
    onMounted(() => {
      getWidth();
      window.addEventListener("resize", getWidth);
      //弹窗内的查询区在弹窗打开时容器尺寸才会从 0 变化，需监听容器尺寸变化重新测量折叠高度
      //观察查询项容器而非根节点：折叠态根节点高度被 maxHeight 钳制，
      //动态增减查询项不会改变根节点尺寸；.q 保持自然布局高度，变化可被捕获
      if (tableBox.value && typeof ResizeObserver !== "undefined") {
        const q = tableBox.value.querySelectorAll(`.${css.q}`)[0];
        resizeObserver = new ResizeObserver(() => measureCollapsedHeight());
        resizeObserver.observe(q || tableBox.value);
      }
    });
    onUnmounted(() => {
      window.removeEventListener("resize", getWidth);
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    });
    //子组件的通信
    provide("size", props.size);
    provide("equal", props.equal);
    return () => _createVNode("div", {
      "style": {
        marginBottom: props.gutter,
        maxHeight: isSpread.value && !visible.value && collapsedMaxHeight.value > 0 ? `${collapsedMaxHeight.value}px` : undefined
      },
      "class": queryClass.value,
      "ref": tableBox
    }, [content.value]);
  }
});